/**
 * Shared form field variant configurations
 * Used across Input, Textarea, MultiSelect, and other form components
 */

/**
 * Active state: Filter is active (in URL/query)
 * - Blue background
 * - Blue border
 * - Blue hover states
 */
export const activeVariantClasses =
	'bg-blue-50 dark:bg-blue-950/20 border-blue-300 dark:border-blue-700 hover:border-blue-400 dark:hover:border-blue-600 focus-visible:border-blue-500';

/**
 * Modified state: User has changed the field (dirty)
 * - Green ring overlay
 * - Adds visual indicator without changing background
 */
export const modifiedVariantClasses = 'border-blue-500';

/**
 * Helper to get variant classes object for CVA
 * @returns {Object} Variant configuration for CVA
 */
export const getFormFieldVariants = () => ({
	variant: {
		default: '',
		active: activeVariantClasses,
	},
	modified: {
		true: modifiedVariantClasses,
		false: '',
	},
});

/**
 * Helper to get default variants for CVA
 * @returns {Object} Default variant values
 */
export const getFormFieldDefaultVariants = () => ({
	variant: 'default',
	modified: false,
});
